import { motion } from "framer-motion";
import { Clock } from "lucide-react";

export default function CallbackSuccess({ onReset }) {
    return (
        <motion.div
            key="confirmation"
            suppressHydrationWarning
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="text-center py-8 md:py-12"
            data-testid="callback-success"
            role="status"
            aria-live="polite"
        >
            <span
                aria-hidden="true"
                className="inline-flex items-center justify-center w-14 h-14 border border-[#C9A86A]/60 text-[#C9A86A] mb-8"
            >
                <Clock size={20} strokeWidth={1.4} />
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-[#F3EFE7] leading-[1.2] mb-4">
                Thank you.
            </h2>
            <p className="text-[#9A958A] text-base md:text-lg leading-[1.8] max-w-md mx-auto">
                A specialist will call you within your selected window.
                Expect contact from a private number.
            </p>
            <button
                type="button"
                onClick={onReset}
                className="mt-10 text-[11px] tracking-[0.28em] uppercase text-[#C9A86A] hover:text-[#D9BC80] transition-colors duration-300"
                data-testid="callback-reset"
            >
                Submit another request
            </button>
        </motion.div>
    );
}
